import React from 'react';
import {Grid,Row,Col} from 'react-flexbox-grid';
import { TypeChart } from "./rowChart";
import { BunitChart } from "./rowChart2";
import { TopicChart } from "./rowChart3";
import { SLevelChart } from "./rowChart4";
import { AgentChart } from "./rowChart5";
//import { BarChart1 } from "./barChart1";
//import { BarChart2 } from "./barChart2";
//import { SeriesChart } from "./seriesChart";
import { RangeChart } from "./rangeChart";
import { HeatMap }  from "./heatMap";
import { TotalConversations }  from "./totalChart";
import { AvgWaitTotal }  from "./avgWaitChart";
import { AvgConversationTotal }  from "./avgWConversationTotal";
import { ServiceLevelTotal }  from "./serviceLevelChart";
import { TagChart }  from "./tagChart";
import TagList from './tagList';
import { DataContext } from "./cxContext";
import { css } from 'glamor';

export const Dashboard = (props)=>{

  const style = css({
      padding:'1rem',
      marginTop:'5px'
  })

  const tagsStyle = {
      //padding:'1rem',
      marginTop:'15px',
      //marginLeft: '100px',
      textAlign: 'center',
      width: '100%'
  }

  const tagsBgdStyle = {
    backgroundColor: '#f7f8fc',
    margin: '10px',
    display: 'flex',
    flexDirection: 'row'
  }

  const tagStyle = {
    // margin: '0',
    padding: 0
  }

  /*
  <Row md={12} >
    <Col md={7} >
      <BarChart1 title="Month" dim="month" />
    </Col >
    <Col md={5} >
      <BarChart2 title="Year" dim="year" />
    </Col >
  </Row>
  <Row >
      <BarChartMonth title="Day of the Month" dim="monthDate" type="barchart"/>
  </Row>
  */

  return(
    <div {...style}>
      <DataContext >
        <Grid fluid>
          <Row>
            <Col md={3} >
              <TotalConversations title="Total Conversations"/>
            </Col>
            <Col md={3} >
              <AvgWaitTotal title="Avg Waiting Time" val="secs"/>
            </Col>
            <Col md={3} >
              <AvgConversationTotal title="Avg Conversation Time" val="secs"/>
            </Col>
            <Col md={3} >
              <ServiceLevelTotal title="Service Level"/>
            </Col>
          </Row>

          <Row  style={tagsBgdStyle}>
            <span style={tagsStyle}>Tags</span>
            <TagList />
          </Row>
            <Row >
              <Col md={3} >
                <Row>
                  <TypeChart title="Type" dim="month" type="rowchart" className="rowchart"/>
                </Row>
                <Row>
                  <BunitChart title="Business Unit" dim="month" type="rowchart" className="rowchart"/>
                </Row>
                <Row>
                  <TopicChart title="Selected Topic" dim="month" type="rowchart" className="rowchart"/>
                </Row>
                <Row>
                  <SLevelChart title="Service Level" dim="month" type="rowchart" className="rowchart"/>
                </Row>
              </Col>
              <Col md={6} >
                <Row >
                  <HeatMap title="Day of the Week vs Hours of the Day" dim="day" type="heatmap"/>
                </Row>
                <Row >
                  <RangeChart title="Activity By Date" dim="monthDate" type="linechart" />
                </Row>
                </Col >
              <Col md={3} >
                <Row >
                <Row>
                  <AgentChart title="Closing Agent" type="rowchart" className="rowchart"/>
                </Row>
                </Row>
              </Col >
            </Row>
          </Grid>
        </DataContext>
      </div>
  )
}
